import { render, staticRenderFns } from "./SolutionWmdsPage.vue?vue&type=template&id=01fbbe9f&scoped=true"
import script from "./SolutionWmdsPage.vue?vue&type=script&lang=js"
export * from "./SolutionWmdsPage.vue?vue&type=script&lang=js"
import style0 from "./SolutionWmdsPage.vue?vue&type=style&index=0&id=01fbbe9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbbe9f",
  null
  
)

export default component.exports